import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Stenbelaegning from './pages/Stenbelaegning';
import LodretStenbelaegning from './pages/LodretStenbelaegning';
import VubaMaterialer from './pages/VubaMaterialer';
import FarverOgDesign from './pages/FarverOgDesign';
import Service from './pages/Service';
import OmOs from './pages/OmOs';
import Referencer from './pages/Referencer';
import ReferenceDetail from './pages/ReferenceDetail';
import Kontakt from './pages/Kontakt';

// ScrollToTop component to ensure pages scroll to top or to anchor on route change
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const timer = setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      return () => clearTimeout(timer);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-stone-800 antialiased selection:bg-emerald-600 selection:text-white pb-16 md:pb-0">
      <ScrollToTop />
      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/helstoebt-stenbelaegning" element={<Stenbelaegning />} />
          <Route path="/lodret-stenbelaegning" element={<LodretStenbelaegning />} />
          <Route path="/vuba-materialer" element={<VubaMaterialer />} />
          <Route path="/farver-og-design" element={<FarverOgDesign />} />
          <Route path="/farver" element={<FarverOgDesign />} />
          <Route path="/service" element={<Service />} />
          <Route path="/om-os" element={<OmOs />} />
          <Route path="/referencer" element={<Referencer />} />
          <Route path="/referencer/:id" element={<ReferenceDetail />} />
          <Route path="/kontakt" element={<Kontakt />} />
          {/* Fallback route */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
